import "./sentry";
import "./index.css";
import "./index.less";

import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";

const rootElement = document.getElementById("root");

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
